//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import HeaderCourseModule from 'app_components/modules/academic/headercourse'
import DescriptionCourseModule from 'app_components/modules/academic/descriptioncourse'
import RelatedCoursesModule from 'app_components/modules/academic/relatedcourses'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../moocScreen.scss'

// @ADD Component types
interface IMoocScreenLayoutProps {}

const MoocScreenLayout: React.FC<IMoocScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <HeaderCourseModule type={'mooc'}/>
      <DescriptionCourseModule/>
      <RelatedCoursesModule type={'mooc'}/>
    </PublicAppLayout>
  )
}

export default MoocScreenLayout
